<!-- eslint-disable max-len -->
<template>
  <div class="about" id="about-page">
    <div class="page-header page-header-bg page-header-about-new"
      style="background-image: url('assets/images/about/about-title.jpg');">
      <div class="container">
        <h1>{{ translations.aboutUs }}</h1>
        <h2>Kompletna rješenja za uspjeh Vašeg poslovanja</h2>
      </div><!-- End .container -->
    </div><!-- End .page-header -->

    <!-- <nav aria-label="breadcrumb" class="breadcrumb-nav">
                <div class="container">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="index.html"><i class="icon-home"></i></a></li>
                        <li class="breadcrumb-item active" aria-current="page">
                            O nama
                        </li>
                    </ol>
                </div>
            </nav> -->

    <div class="about-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">TKO SMO MI?</h2>
            <p>Eurosan Ecotime grupacija nastala je 1998. godine inspirirana željom za zdravijim i sretnijim radnim
              prostorima.
              Na&scaron; cilj je jasan: biti Va&scaron; pouzdan partner u održavanju čistoće, higijene i sigurnosti.
              Vjerujemo
              da čisto i sigurno radno okruženje pokreće uspjeh.</p>
            <p>&bdquo;Zdravije, sigurnije, produktivnije&ldquo; &ndash; to je na&scaron;e obećanje Vama!</p>
            <p>Kroz na&scaron;e sveobuhvatne usluge i proizvode &ndash; od profesionalnog či&scaron;ćenja do
              ekolo&scaron;ki
              prihvatljivih proizvoda i za&scaron;titne opreme &ndash; mi stvaramo prostore u kojima ljudi di&scaron;u
              lak&scaron;e, rade učinkovitije i žive zdravije.</p>
            <p>Odaberite nas i pridružite nam se u stvaranju zdravije i sigurnije budućnosti.</p>
          </div><!-- End .col-lg-12 -->

        </div><!-- End .row -->
      </div><!-- End .container -->
    </div><!-- End .about-section -->
    <div class="content-boxes-section">
      <div class="container">
        <div class="row">
          <div class="col-md-4 border-rignt-col">
            <div class="content-box">
              <img style="text-align: center;" src="assets/images/about/icon-1-target.jpg" />
              <h2 class="box-title" style="text-align: center;">NAŠA MISIJA</h2>
              <p style="text-align: center;">Biti vaš pouzdani partner u stvaranju čistog, sigurnog i održivog okruženja
                kroz prilagođena rješenja i iznimnu uslugu.</p>
            </div>
          </div>
          <div class="col-md-4 border-rignt-col">
            <div class="content-box">
              <img style="text-align: center;" src="assets/images/about/icon-2-bulb.jpg" />
              <h2 class="box-title" style="text-align: center;">NAŠA VIZIJA</h2>
              <p style="text-align: center;">Postati lider u pružanju održivih i prilagođenih rješenja za čišću,
                zdraviju i sigurniju budućnost, uvijek stavljajući potrebe naših klijenata na prvo mjesto.</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="content-box">
              <img style="text-align: center;" src="assets/images/about/icon-3-hands.jpg" />
              <h2 class="box-title" style="text-align: center;">NAŠE VRIJEDNOSTI</h2>
              <p style="text-align: center;">Naše temeljne vrijednosti označavaju ono što jesmo, što radimo i način na
                koji to radimo, a one su visok kvalitet usluga i proizvoda, znanje o higijeni i briga o sigurnosti i
                zdravlju ljudi.</p>
            </div>
          </div>
        </div>
      </div><!-- End .container -->
    </div><!-- End .content-box-section -->

    <div class="about-section section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">ZAŠTO NAS ODABRATI?</h2>
            <ul>
              <li><span class="blue-bold-text">&#x2022; UČINKOVITOST:</span> Čistite pametnije, radite manje.</li>
              <li><span class="blue-bold-text">&#x2022; POBOLJŠANA HIGIJENA:</span> Izvanredna razina higijene za svaki
                prostor.</li>
              <li><span class="blue-bold-text">&#x2022; DJELOTVORNO ČIŠĆENJE:</span> Snaga čistoće u svakoj ambalaži.
              </li>
              <li><span class="blue-bold-text">&#x2022; POBOLJŠANA SIGURNOST RADNIKA:</span> Zaštitite svoje radnike
                vrhunskom zaštitnom opremom.</li>
              <li><span class="blue-bold-text">&#x2022; POBOLJŠANO GASTRONOMSKO ISKUSTVO:</span> Atmosfera koja odiše
                luksuzom i kvalitetom.</li>
              <li><span class="blue-bold-text">&#x2022; VEĆE ZADOVOLJSTVO GOSTIJU:</span> Ekološki prihvatljiva hotelska
                kozmetika vrhunske kvalitete.</li>
              <li><span class="blue-bold-text">&#x2022; UŠTEDA VREMENA:</span> UŠtedite vrijeme i energiju &ndash;
                prepustite brigu o čišćenju nama.</li>
              <li><span class="blue-bold-text">&#x2022; DUŽI VIJEK TRAJANJA OPREME:</span> Za bezbrižnost &ndash; Vaša
                oprema u sigurnim rukama našeg servisa.</li>
            </ul>
          </div><!-- End .col-lg-12 -->
        </div><!-- End .row -->
      </div><!-- End .container -->
    </div><!-- End .about-section -->

    <div class="carousel-section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="carousel-title">Ponosno smo na usluzi više od <span class="blue-bold-text">3.000 klijenata</span>
              u BiH, Srbiji i Crnoj Gori</h2>

            <Carousel v-bind="carouselSettings" class="owl-theme">
              <template slot="prev">
                <button type="button" role="presentation" class="owl-prev"><i class="icon-left-open-big"></i></button>
              </template>

              <template slot="next">
                <button type="button" role="presentation" class="owl-next"><i class="icon-right-open-big"></i></button>
              </template>

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Alloy-Wheels.png"
                      alt="Alloy Wheels" width="150" height="50"></p>
                  <p class="company-title">Alloy Wheels d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Jajce</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\CocaCola.png"
                      alt="Coca Cola" width="150" height="50"></p>
                  <p class="company-title">Coca Cola d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Sarajevo</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Emerus.png"
                      alt="Emerus" width="150" height="50"></p>
                  <p class="company-title">Emerus d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Široki Brijeg</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\EPHZHB.png"
                      alt="EP HZ-HB" width="150" height="50"></p>
                  <p class="company-title">EP HZ-HB</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Mostar</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Kiseljak.png"
                      alt="Sarajevski kiseljak" width="150" height="50"></p>
                  <p class="company-title">Sarajevski kiseljak d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Sarajevo</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Konzum.png"
                      alt="Konzum" width="150" height="50"></p>
                  <p class="company-title">Konzum d.d.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Sarajevo</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Marriott.png"
                      alt="Marriott" width="150" height="50"></p>
                  <p class="company-title">Marriott d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Sarajevo</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Meggle.png"
                      alt="Meggle" width="150" height="50"></p>
                  <p class="company-title">Marriott d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Bihać</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image"
                      src="assets\images\about\clients\mepas-mall-horizontal.png" alt="Mepas Mall" width="150"
                      height="50"></p>
                  <p class="company-title">Mepas Mall d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Mostar</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Swissotel.png"
                      alt="Swissotel" width="150" height="50"></p>
                  <p class="company-title">Swissotel</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Sarajevo</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Unicredit-Bank.png"
                      alt="UniCredit Bank" width="150" height="50"></p>
                  <p class="company-title">UniCredit Bank d.d.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Mostar</span></p>
                </div>
              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Banja-vrucica.png"
                      alt="Banja Vrućica" width="150" height="50"></p>
                  <p class="company-title">Banja Vrućica d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Teslić</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Mljecanica.png"
                      alt="Mlječanica" width="150" height="50"></p>
                  <p class="company-title">Mlječanica d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Kozarska Dubica</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\MF-Grupa.png"
                      alt="MF grupa" width="150" height="50"></p>
                  <p class="company-title">MF grupa d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Banja Luka</span></p>
                </div>

              </div><!-- End of client-box-->

              <div class="client-box">

                <div class=""
                  style="padding: 10%; margin: 0px 5%; background-color: rgb(255, 255, 255); min-height: 110px;">
                  <p><img decoding="async" class="company-image" src="assets\images\about\clients\Fructa-trade.png"
                      alt="Fructa trade" width="150" height="50"></p>
                  <p class="company-title">Fructa trade d.o.o.</p>
                  <p class="company-state">Bosna i Hercegovina<br><br></p>
                  <hr style="margin: 2rem 0 0">
                  <p class="company-city-wrapper"><img decoding="async" class=""
                      src="assets/images/about/Icon-ionic-ios-pin.png" alt="" width="9" height="13"> <span
                      class="company-city">Derventa</span></p>
                </div>
              </div><!-- End of client-box-->
            </Carousel>

          </div>
        </div><!-- End .row -->
      </div><!-- End .container -->
    </div><!-- End .carousel-section -->

    <div class="features-section counter-box-section">
      <div class="container">
        <div class="row">
          <div class="col-md-4 counter-box-wrapper">
            <div class="counter">
              <h2 class="timer count-title count-number" data-to="26" data-speed="1500"></h2>
              <p class="count-text ">Godina postojanja</p>
            </div>
          </div><!-- End .col-md-4 -->

          <div class="col-md-4 counter-box-wrapper">
            <div class="counter">
              <h2 class="timer count-title count-number" data-to="394" data-speed="1500"></h2>
              <p class="count-text ">Djelatnika</p>
            </div>
          </div><!-- End .col-md-4 -->

          <div class="col-md-4 counter-box-wrapper">
            <div class="counter">
              <h2 class="timer count-title count-number" data-to="3547" data-speed="1500"></h2>
              <p class="count-text ">Aktivnih artikala</p>
            </div>
          </div><!-- End .col-md-4 -->

        </div><!-- End .row -->
      </div><!-- End .container -->
      <div class="half-blue-bg"></div>
    </div><!-- End .counter-box-section -->
  </div>
</template>

<script>
import Carousel from 'vue-owl-carousel';
import { translations } from '@/mixins';

export default {
  name: 'About',
  mixins: [translations],
  data() {
    return {
      carouselSettings: {
        margin: 10,
        items: 2,
        autoplayTimeout: 5000,
        dots: false,
        nav: false,
        responsive: {
          576: {
            items: 3,
          },
          975: {
            items: 4,
          },
          1200: {
            items: 6,
          },
        },
      },
      observer: null,
    };
  },
  components: {
    Carousel,
  },
  methods: {
    initCounters() {
      console.log('initCounters called');
      $('.count-number').each(function counter() {
        const $this = $(this);
        const countTo = $this.attr('data-to');

        $({ countNum: $this.text() }).animate({
          countNum: countTo,
        },
        {
          duration: 1500,
          easing: 'linear',
          step() {
            $this.text(Math.floor(this.countNum));
          },
          complete() {
            $this.text(this.countNum);
          },
        });
      });

      const target = document.querySelector('.counter-box-section');
      this.observer.unobserve(target);
    },
    init() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };

      // Use an arrow function to maintain the `this` context if needed
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.initCounters(); // Ensure `this` is bound correctly if using a class
          }
        });
      }, options);

      const target = document.querySelector('.counter-box-section');
      if (target) {
        this.observer.observe(target);
      } else {
        console.error('Target element not found');
      }
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.init();
    }, 1000);
  },
};
</script>
<style>
.owl-carousel {
  position: relative;
}

.owl-next,
.owl-prev {
  position: absolute;
  top: 48%;
  background-color: #e8e8e870;
  color: #222529;
  padding: 1.5rem 0 !important;
  border: 1px solid #e8e8e870;
  z-index: 2;
  width: 25px;
  cursor: pointer;
}

.owl-next {
  right: 15px;
}

.owl-prev {
  left: 15px;
}
</style>
